import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { LoadingController, } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'shc-contact',
  templateUrl: './contact.page.html',
  styleUrls: ['./contact.page.scss'],
})
export class ContactPage implements OnInit {

  form: UntypedFormGroup;
  constructor(
    private router: Router,
    private userService: UserService,
    private translate: TranslateService,
    private loadingCtrl: LoadingController,
    private errorHandler: ErrorHandlerService,
  ) { }

  ngOnInit() {
    const emailPattern = '[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,63}';
    this.form = new UntypedFormGroup({
      title: new UntypedFormControl(null, [
        Validators.required
      ]),
      name: new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern('^[a-zA-Z ]*$')
      ]),
      email: new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern(emailPattern)
      ]),
      message: new UntypedFormControl(null, [
        Validators.required,
        Validators.maxLength(300)
      ])
    });
  }

  ionViewWillEnter() { }

  openWhatsapp(): void {
    (window as any).cordova.InAppBrowser.open('https://api.whatsapp.com/send/?phone=31102613250', '_system');
  }

  onContact(): void {
    this.loadingCtrl.create({
      message: this.translate.instant(marker('Loading'))
    }).then(loadingEl => {
      loadingEl.present();
      this.userService.contactUs(this.form.value).subscribe(
        (res: any) => {
          loadingEl.dismiss();
          this.form.reset();
          this.router.navigate(['/tabs/home']);
        },
        error => {
          loadingEl.dismiss();
          this.errorHandler.handle(error);
        }
      );
    });
  }

}
